import { ComponentPropsWithRef, ReactNode } from "react";
import { clsx } from "clsx";
import { roleColors } from "@/utils/roleColors";
import styles from "./Card.module.css";

export type CardProps = {
  children?: ReactNode;
  tint?: roleColors;
} & ComponentPropsWithRef<"div">;

export function Card({ children, className, tint, ...rest }: CardProps) {
  return (
    <div className={clsx(styles.cardRoot, className)} data-tint={tint} {...rest}>
      {children}
    </div>
  );
}
